import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
import 'firebase/compat/storage';
import { FireFilter } from '../../shared/types';
import { analyticsService } from "../analytics";

export const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
} else {
    firebase.app(); // if already initialized, use that one
}

export const firestore = firebase.firestore();
export const storage = firebase.storage();

// const functions = firebase.functions();

// if (window.location.hostname === "localhost") {
//     firestore.useEmulator("localhost", 8080);
//     functions.useEmulator("localhost", 5001);
// }

// TO TEST A PUBSUB FUNCTION USING THE EMULATOR...
// TJN TO-DO: MAYBE... create a mini interface for this...
// const testPubSub = firebase.functions().httpsCallable('testPubSub');
// testPubSub({ topic: 'firebase-schedule-syncWithAirtable' });

export function logDatabaseReads(functionName: string, docCount: number, simpleFilter?: FireFilter, comboFilter?: string) {
    const databaseReadParams = {
        functionName: functionName,
        docCount: docCount,
        url: window.location.pathname,
        filter: simpleFilter,
        comboFilter: comboFilter,
    };

    if (window.location.hostname === "localhost" || (window as any).logGrail) {
        console.warn(`logDatabaseReads`, {
            ...databaseReadParams,
            filter: JSON.stringify(simpleFilter)
        });
    }

    if (!functionName.includes('cached')) {
        analyticsService().logEvent('Queried Firestore', databaseReadParams);
    }
}
